<template>
  <template v-if="seminarDetails">
    <div class="bg-blue-100 border-blue-400 text-blue-700 border px-4 py-3 rounded">
      <template v-if="seminarDetails.seminar_category_id === 1">
        {{ categoryName }}の参加登録を、
        <br>「{{ seminarDetails.seminar_user.seminar_status.name }}」で受付いたしました。
      </template>
      <template v-else>
        {{ categoryName }}の参加登録を受付いたしました。
      </template>
      <br>
      <br>受付番号は
      <br><span class="text-3xl font-medium">[{{ seminarDetails.seminar_user.order_key }}]</span>
      <br>になります。
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { SeminarAttributes } from '@/types/models/seminar'

export default defineComponent({
  props: {
    seminarDetails: {
      type: Object as PropType<SeminarAttributes | undefined>,
      'default': () => (undefined),
    }
  },
  setup(props) {
    const categoryName = computed((): string => {
      if (props.seminarDetails) {
        return props.seminarDetails.seminar_category.id === 1 || props.seminarDetails.seminar_category.id === 2 ? 'セミナー' : props.seminarDetails.seminar_category.name
      }
      return ''
    })

    return {
      categoryName
    }
  },
})
</script>
